"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.languageQuery = exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _hoc = require("@apollo/client/react/hoc");
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _getLocaleFromPreferences = _interopRequireDefault(require("../../utils/getLocaleFromPreferences"));
const languageQuery = exports.languageQuery = (0, _graphqlTag.default)("\n    query preferencesAndUserDetails {\n        preferences {\n            userLanguage\n        }\n    }\n");
function withLocale(Component) {
  const Wrapped = _ref => {
    let {
      localeQuery,
      ...rest
    } = _ref;
    return /*#__PURE__*/React.createElement(Component, Object.assign({}, rest, {
      locale: (0, _getLocaleFromPreferences.default)(localeQuery)
    }));
  };
  return (0, _hoc.graphql)(languageQuery, {
    name: 'localeQuery',
    options: {
      fetchPolicy: 'cache-only'
    }
  })(Wrapped);
}
var _default = exports.default = withLocale;